import React from "react";

/**
* Spinner Component
* -----------------
* Used to indicate loading - often used in a button, while a backend task is being executed.
*/

interface SpinnerProps {
    className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ className }) => {
    return (
        <div className={`
        h-4 w-4
        border-2 border-white
        border-t-transparent
        rounded-full
        animate-spin
        ${className ?? ""}
      `}></div>
    );
};
